export interface IPostParams {
    /** Data to post */
    postdata: { [key: string]: string };
    /** The url to navigate to */
    url: string;
  }
  export interface INavigateViaPostParams extends IPostParams {
    /** The HTML document to write the form in. Generally obtained as either window.open('', _blank).document or iframe.contentDocument */
    document: Document;
  }
  export const navigateViaPost = (params: INavigateViaPostParams): void => {
    let root: Document = params.document;
    if (!root.body) {
      root.createElement('body');
    }
    // Create form in target iframe/window, post
    let form = root.createElement('form');
    form.action = params.url;
    form.method = 'POST';
    form.style.visibility = 'hidden';
    form.target = '_self';
    const postdata = params.postdata;
    for (const param in postdata) {
      if (postdata.hasOwnProperty(param)) {
      const input = root.createElement('input');
      input.type = 'hidden';
      input.name = param;
      input.value = postdata[param];
      form.appendChild(input);
      }
    }
    root.body.appendChild(form);
    form.submit();
  };